import {
  AbastecimentoForm,
  AbastecimentoList as AbastecimentoListView,
  AdmSisarePassengerAnalytics,
  AdmSisarePassengerForm,
  AdmSisarePassengerList,
  AgendaEscalaFornecedorForm,
  AgendaEscalaFornecedorList as AgendaEscalaFornecedorListView,
  CategoriaServicoForm,
  CategoriaServicoList as CategoriaServicoListView,
  ClienteList as ClienteListView,
  Dashboard as DashboardView,
  FaleConosco as FaleConoscoView,
  FormPax as FormPaxView,
  Hospedagem as HospedagemView,
  Login as LoginView,
  LoginAppCli as LoginAppCliView,
  LoginViewPartner as LoginPartner,
  Logout as LogoutView,
  MapaOperacao as MapaOperacaoView,
  MarcaVeiculoForm,
  MarcaVeiculoList as MarcaVeiculoListView,
  MenuAdministrativo as MenuAdministrativoView,
  MenuFinanceiro as MenuFinanceiroView,
  MenuOperacional as MenuOperacionalView,
  MenuProducao as MenuProducaoView,
  MenuProgramacao as MenuProgramacaoView,
  ModeloVeiculoForm,
  ModeloVeiculoList as ModeloVeiculoListView,
  MotivoCancelamentoForm,
  MotivoCancelamentoList as MotivoCancelamentoListView,
  OpcionalVeiculoForm,
  OpcionalVeiculoList as OpcionalVeiculoListView,
  OS as OSView,
  OSList as OSListView,
  OsManutVeiculoForm,
  OsManutVeiculoList as OsManutVeiculoListView,
  ServicoForm,
  ServicoList as ServicoListView,
  TipoVeiculoForm,
  TipoVeiculoList as TipoVeiculoListView,
  UsuarioPartnerForm,
  UsuarioPartnerList as UsuarioPartnerListView,
  VeiculoForm,
  VeiculoList as VeiculoListView,
  VendedorForm,
  VendedorList as VendedorListView
} from 'views';
import {
  AMODULO_ADMAPPCLI,
  AMODULO_CRM,
  AMODULO_FINANCAS,
  AMODULO_FRONT,
  AMODULO_FROTAS,
  AMODULO_GERENCIAL,
  AMODULO_PARTNER
} from 'consts';
import {
  Main as MainLayout,
  Minimal as MinimalLayout
} from 'layouts';
import {
  AccountBalance as AccountBalanceIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Assessment as AssessmentIcon,
  Assignment as AssignmentIcon,
  AssignmentOutlined as AssignmentOutlinedIcon,
  Build as BuildIcon,
  Business as BusinessIcon,
  Category as CategoryIcon,
  Chat as ChatIcon,
  Commute as CommuteIcon,
  DashboardOutlined as DashboardOutlinedIcon,
  Description as DescriptionIcon,
  DriveEtaOutlined as DriveEtaOutlinedIcon,
  EmojiTransportation as EmojiTransportationIcon,
  Event as EventIcon,
  ExitToAppRounded as ExitToAppRoundedIcon,
  FormatListBulletedRounded as FormatListBulletedRoundedIcon,
  Forum as ForumIcon,
  Group as GroupIcon,
  GroupWorkOutlined as GroupWorkOutlinedIcon,
  HomeOutlined as HomeOutlinedIcon,
  LocalGasStationOutlined as LocalGasStationOutlinedIcon,
  Message as MessageIcon,
  MonetizationOn as MonetizationOnIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  PinDropRounded as PinDropRoundedIcon,
  PollRounded as PollRoundedIcon,
  PostAddRounded as PostAddRoundedIcon,
  Public as PublicIcon,
  QueueOutlined as QueueOutlinedIcon,
  Receipt as ReceiptIcon,
  Schedule as ScheduleIcon,
  Send as SendIcon,
  SupervisorAccount as SupervisorAccountIcon,
  Today as TodayIcon,
  WidgetsOutlined as WidgetsOutlinedIcon
} from '@material-ui/icons';
import React from 'react';
import { PERMS } from 'permissions';

/* Define as rotas da aplicação, com layout, módulo e permissão de cada uma */
export const appRoutes = [
  // geral
  {
    path: '/login',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/logout',
    exact: true,
    component: LogoutView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },

  // gerencial
  {
    path: '/gerencial',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/gerencial/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuproducao',
    exact: true,
    component: MenuProducaoView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_PRODUCAO,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuoperacional',
    exact: true,
    component: MenuOperacionalView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_OPERACIONAL,
    authType: 'internal'
  },
  {
    path: '/gerencial/menufinanceiro',
    exact: true,
    component: MenuFinanceiroView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_FINANCEIRO,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuadministrativo',
    exact: true,
    component: MenuAdministrativoView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_ADMINISTRATIVO,
    authType: 'internal'
  },

  // frotas
  {
    path: '/frotas',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/frotas/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/frotas/veiculo',
    exact: true,
    component: VeiculoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/veiculo/:id',
    component: VeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/marcaveiculo',
    exact: true,
    component: MarcaVeiculoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_MARCA_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/marcaveiculo/:id',
    component: MarcaVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_MARCA_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/modeloveiculo',
    exact: true,
    component: ModeloVeiculoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_MODELO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/modeloveiculo/:id',
    component: ModeloVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_MODELO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/tipoveiculo',
    exact: true,
    component: TipoVeiculoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_TIPO_DE_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/tipoveiculo/:id',
    component: TipoVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_TIPO_DE_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/opcionalveiculo',
    exact: true,
    component: OpcionalVeiculoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_OPCIONAL_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/opcionalveiculo/:id',
    component: OpcionalVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_OPCIONAL_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/abastecimento',
    exact: true,
    component: AbastecimentoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTO_ABASTECIMENTO,
    authType: 'internal'
  },
  {
    path: '/frotas/abastecimento/:id',
    component: AbastecimentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTO_ABASTECIMENTO,
    authType: 'internal'
  },
  {
    path: '/frotas/osmanutveiculo',
    exact: true,
    component: OsManutVeiculoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTO_OS_MANUTENCAO,
    authType: 'internal'
  },
  {
    path: '/frotas/osmanutveiculo/:id',
    component: OsManutVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTO_OS_MANUTENCAO,
    authType: 'internal'
  },

  // front
  {
    path: '/front',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/front/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/oss',
    exact: true,
    component: OSListView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 12018,
    authType: 'internal'
  },
  {
    path: '/front/os/:id',
    component: OSView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/pax/:id',
    exact: true,
    component: FormPaxView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/mapaoperacao',
    exact: true,
    component: MapaOperacaoView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/categoriasservicos',
    exact: true,
    component: CategoriaServicoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/categoriasservicos/:id',
    component: CategoriaServicoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/servicos',
    exact: true,
    component: ServicoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/servicos/:id',
    component: ServicoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/motivoscancelamentos',
    exact: true,
    component: MotivoCancelamentoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/motivoscancelamentos/:id',
    component: MotivoCancelamentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/vendedores',
    exact: true,
    component: VendedorListView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/vendedores/:id',
    component: VendedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/clientes',
    exact: true,
    component: ClienteListView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/tipoveiculo',
    exact: true,
    component: TipoVeiculoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/tipoveiculo/:id',
    component: TipoVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },

  // finanças
  {
    path: '/financas',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/financas/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: 0,
    authType: 'internal'
  },

  // CRM
  {
    path: '/crm',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/crm/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: 0,
    authType: 'internal'
  },

  // appcli
  {
    path: '/appcli/login',
    exact: true,
    component: LoginAppCliView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'passenger'
  },
  {
    path: '/appcli',
    exact: true,
    component: LoginAppCliView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'passenger'
  },
  {
    path: '/appcli/programacao',
    exact: true,
    component: MenuProgramacaoView,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/hospedagem',
    exact: true,
    component: HospedagemView,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/faleconosco',
    exact: true,
    component: FaleConoscoView,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/:localizador',
    exact: true,
    component: LoginAppCliView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },

  // adm appcli
  {
    path: '/admappcli',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/admappcli/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger-list',
    exact: true,
    component: AdmSisarePassengerList,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger-analytics',
    exact: true,
    component: AdmSisarePassengerAnalytics,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 36006,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger/:id',
    exact: true,
    component: AdmSisarePassengerForm,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },

  // partner
  {
    path: '/partner',
    exact: true,
    component: LoginPartner,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/partner/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal',
    redirectTo: '/partner'
  },
  {
    path: '/partner/agendaescalafornecedor',
    exact: true,
    component: AgendaEscalaFornecedorListView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'partner',
    redirectTo: '/partner'
  },
  {
    path: '/partner/agendaescalafornecedor/:id',
    component: AgendaEscalaFornecedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'partner',
    redirectTo: '/partner'
  },

  // adm partner
  {
    path: '/admpartner',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/admpartner/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admpartner/agendaescalafornecedor',
    exact: true,
    component: AgendaEscalaFornecedorListView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admpartner/agendaescalafornecedor/:id',
    component: AgendaEscalaFornecedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal',
    redirectTo: '/admpartner'
  },
  {
    path: '/admpartner/usuariopartner',
    exact: true,
    component: UsuarioPartnerListView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admpartner/usuariopartner/:id',
    component: UsuarioPartnerForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  },

  // estoque
  {
    path: '/estoque',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  }
];

/* Define os itens de menu exibidos para cada módulo */
export const menuByModule = {
  // gerencial
  [AMODULO_GERENCIAL]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: HomeOutlinedIcon,
      to: '/gerencial/dashboard'
    },
    {
      key: 'producao',
      labelKey: 'MENU_PRODUCAO',
      fallbackLabel: 'Produção',
      icon: PollRoundedIcon,
      to: '/gerencial/menuproducao',
      permCode: PERMS.GERENCIAL_MENU_PRODUCAO
    },
    {
      key: 'operacional',
      labelKey: 'MENU_OPERACIONAL',
      fallbackLabel: 'Operacional',
      icon: PinDropRoundedIcon,
      to: '/gerencial/menuoperacional',
      permCode: PERMS.GERENCIAL_MENU_OPERACIONAL
    },
    {
      key: 'financeiro',
      labelKey: 'MENU_FINANCEIRO',
      fallbackLabel: 'Financeiro',
      icon: MonetizationOnIcon,
      to: '/gerencial/menufinanceiro',
      permCode: PERMS.GERENCIAL_MENU_FINANCEIRO
    },
    {
      key: 'administrativo',
      labelKey: 'MENU_ADMINISTRATIVO',
      fallbackLabel: 'Administrativo',
      icon: TodayIcon,
      to: '/gerencial/menuadministrativo',
      permCode: PERMS.GERENCIAL_MENU_ADMINISTRATIVO
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  // frotas
  [AMODULO_FROTAS]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/frotas/dashboard'
    },
    {
      key: 'cadastro',
      labelKey: 'MENU_ITEM_CADASTRO',
      fallbackLabel: 'Cadastro',
      icon: PostAddRoundedIcon,
      children: [
        {
          key: 'veiculos-root',
          labelKey: 'MENU_VEICULOS',
          fallbackLabel: 'Veículos',
          icon: DriveEtaOutlinedIcon,
          children: [
            {
              key: 'veiculo',
              labelKey: 'MENU_VEICULOS',
              fallbackLabel: 'Veículos',
              icon: DriveEtaOutlinedIcon,
              to: '/frotas/veiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO
            },
            {
              key: 'marcas',
              labelKey: 'MENU_MARCAS',
              fallbackLabel: 'Marcas',
              icon: CommuteIcon,
              to: '/frotas/marcaveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_MARCA_VEICULO
            },
            {
              key: 'modelos',
              labelKey: 'MENU_MODELOS',
              fallbackLabel: 'Modelos',
              icon: EmojiTransportationIcon,
              to: '/frotas/modeloveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_MODELO_VEICULO
            },
            {
              key: 'tipos',
              labelKey: 'MENU_TIPOS',
              fallbackLabel: 'Tipos',
              icon: WidgetsOutlinedIcon,
              to: '/frotas/tipoveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_TIPO_DE_VEICULO
            },
            {
              key: 'opcionais',
              labelKey: 'MENU_OPCIONAIS',
              fallbackLabel: 'Opcionais',
              icon: WidgetsOutlinedIcon,
              to: '/frotas/opcionalveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_OPCIONAL_VEICULO
            }
          ]
        }
      ]
    },
    {
      key: 'procedimentos',
      labelKey: 'MENU_PROCEDIMENTOS',
      fallbackLabel: 'Procedimentos',
      icon: FormatListBulletedRoundedIcon,
      children: [
        {
          key: 'abastecimentos-root',
          labelKey: 'MENU_ABASTECIMENTOS',
          fallbackLabel: 'Abastecimentos',
          icon: LocalGasStationOutlinedIcon,
          children: [
            {
              key: 'abastecimento-lancar',
              labelKey: 'MENU_LANCAR',
              fallbackLabel: 'Lançar',
              icon: QueueOutlinedIcon,
              to: '/frotas/abastecimento',
              permCode: PERMS.FROTAS_MENU_PROCEDIMENTO_ABASTECIMENTO
            }
          ]
        },
        {
          key: 'osmanutencao-root',
          labelKey: 'MENU_OS_MANUTENCAO',
          fallbackLabel: 'OS de Manutenção',
          icon: AssignmentOutlinedIcon,
          children: [
            {
              key: 'osmanutencao-lancar',
              labelKey: 'MENU_LANCAR',
              fallbackLabel: 'Lançar',
              icon: QueueOutlinedIcon,
              to: '/frotas/osmanutveiculo',
              permCode: PERMS.FROTAS_MENU_PROCEDIMENTO_OS_MANUTENCAO
            }
          ]
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  // front
  [AMODULO_FRONT]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/front/dashboard'
    },
    {
      key: 'cadastro',
      labelKey: 'MENU_ITEM_CADASTRO',
      fallbackLabel: 'Cadastro',
      icon: PostAddRoundedIcon,
      children: [
        {
          key: 'servicos-root',
          labelKey: 'MENU_SERVICOS',
          fallbackLabel: 'Serviços',
          icon: BuildIcon,
          children: [
            {
              key: 'servicos',
              labelKey: 'MENU_ITEM_SERVICOS',
              fallbackLabel: 'Serviços',
              icon: BuildIcon,
              to: '/front/servicos'
            },
            {
              key: 'motivoscancelamentos',
              labelKey: 'MENU_MOTIVOS_CANCELAMENTO',
              fallbackLabel: 'Motivos de Cancelamento',
              icon: AssignmentOutlinedIcon,
              to: '/front/motivoscancelamentos'
            },
            {
              key: 'categorias-servicos',
              labelKey: 'MENU_CATEGORIAS_SERVICOS',
              fallbackLabel: 'Categorias de Serviços',
              icon: CategoryIcon,
              to: '/front/categoriasservicos',
              permCode: 12002
            }
          ]
        },
        {
          key: 'veiculos-root',
          labelKey: 'MENU_TIPO_VEICULO',
          fallbackLabel: 'Veículos',
          icon: DriveEtaOutlinedIcon,
          children: [
            {
              key: 'tipoveiculo',
              labelKey: 'MENU_TIPO_VEICULO',
              fallbackLabel: 'Tipo de Veículo',
              icon: DriveEtaOutlinedIcon,
              to: '/front/tipoveiculo'
            }
          ]
        },
        {
          key: 'clientes-root',
          labelKey: 'MENU_CLIENTES',
          fallbackLabel: 'Clientes',
          icon: PeopleIcon,
          children: [
            {
              key: 'clientes',
              labelKey: 'MENU_CLIENTES',
              fallbackLabel: 'Clientes',
              icon: PeopleIcon,
              to: '/front/clientes'
            }
          ]
        },
        {
          key: 'vendedores',
          labelKey: 'MENU_VENDEDORES',
          fallbackLabel: 'Vendedores',
          icon: PersonIcon,
          to: '/front/vendedores'
        },
        {
          key: 'usuarios',
          labelKey: 'MENU_USUARIOS',
          fallbackLabel: 'Usuários',
          icon: SupervisorAccountIcon,
          to: '/front/users'
        }
      ]
    },
    {
      key: 'operacao',
      labelKey: 'MENU_OPERACAO',
      fallbackLabel: 'Procedimentos',
      icon: AssignmentIcon,
      children: [
        {
          key: 'oss',
          labelKey: 'MENU_ORDENS_SERVICO',
          fallbackLabel: 'Ordens de Serviço',
          to: '/front/oss',
          icon: AssignmentOutlinedIcon,
          permCode: 12018
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  // finanças
  [AMODULO_FINANCAS]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/financas/dashboard'
    },
    {
      key: 'cadastros',
      labelKey: 'MENU_ITEM_CADASTRO',
      fallbackLabel: 'Cadastros',
      icon: PostAddRoundedIcon,
      children: [
        {
          key: 'historicosbancarios',
          fallbackLabel: 'Históricos Bancários',
          icon: DescriptionIcon,
          to: '/financas/historicosbancarios'
        },
        {
          key: 'tiposdocumentos',
          fallbackLabel: 'Tipos de Documentos',
          icon: DescriptionIcon,
          to: '/financas/tiposdocumentos'
        },
        {
          key: 'contascorrentes',
          fallbackLabel: 'Contas Correntes',
          icon: AccountBalanceWalletIcon,
          to: '/financas/contascorrentes'
        },
        {
          key: 'transacoes',
          fallbackLabel: 'Transações',
          icon: ReceiptIcon,
          to: '/financas/transacoes'
        },
        {
          key: 'bancos',
          fallbackLabel: 'Bancos',
          icon: AccountBalanceIcon,
          to: '/financas/bancos'
        },
        {
          key: 'setores',
          fallbackLabel: 'Setores',
          icon: BusinessIcon,
          to: '/financas/setores'
        },
        {
          key: 'feriados',
          fallbackLabel: 'Feriados',
          icon: EventIcon,
          to: '/financas/feriados'
        },
        {
          key: 'paises',
          fallbackLabel: 'Países',
          icon: PublicIcon,
          to: '/financas/paises'
        }
      ]
    },
    {
      key: 'fechamento',
      fallbackLabel: 'Fechamento Financeiro',
      icon: MonetizationOnIcon,
      children: [
        {
          key: 'fechamentofinanceiro',
          fallbackLabel: 'Executar Fechamento',
          icon: QueueOutlinedIcon,
          to: '/financas/fechamentofinanceiro'
        },
        {
          key: 'fechamentosfinanceiros',
          fallbackLabel: 'Histórico de Fechamentos',
          icon: FormatListBulletedRoundedIcon,
          to: '/financas/fechamentosfinanceiros'
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  // CRM
  [AMODULO_CRM]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/crm/dashboard'
    },
    {
      key: 'whatsapp',
      fallbackLabel: 'WhatsApp',
      icon: ForumIcon,
      children: [
        {
          key: 'grupos-msg-whatsapp',
          fallbackLabel: 'Grupos de Mensagens',
          icon: GroupIcon,
          to: '/crm/grupomsgwhatsappfornecedor'
        },
        {
          key: 'msg-whatsapp',
          fallbackLabel: 'Mensagens',
          icon: MessageIcon,
          to: '/crm/msgwhatsappfornecedor'
        },
        {
          key: 'envio-whatsapp',
          fallbackLabel: 'Envio',
          icon: SendIcon,
          to: '/crm/enviowhatsappfornecedor'
        },
        {
          key: 'chat-whatsapp',
          fallbackLabel: 'Chat',
          icon: ChatIcon,
          to: '/crm/chatwhatsapp'
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  // adm appcli
  [AMODULO_ADMAPPCLI]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/admappcli/dashboard'
    },
    {
      key: 'passageiros',
      fallbackLabel: 'Sisare Passenger',
      icon: PeopleIcon,
      children: [
        {
          key: 'adm-sisare-passenger-list',
          fallbackLabel: 'Passageiros',
          icon: PeopleIcon,
          to: '/admappcli/adm-sisare-passenger-list'
        },
        {
          key: 'adm-sisare-passenger-analytics',
          fallbackLabel: 'Analytics',
          icon: AssessmentIcon,
          to: '/admappcli/adm-sisare-passenger-analytics'
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  // adm partner
  [AMODULO_PARTNER]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/admpartner/dashboard'
    },
    {
      key: 'agenda',
      fallbackLabel: 'Agenda Escala Fornecedor',
      icon: ScheduleIcon,
      to: '/admpartner/agendaescalafornecedor'
    },
    {
      key: 'usuarios-partner',
      fallbackLabel: 'Usuários Partner',
      icon: GroupWorkOutlinedIcon,
      to: '/admpartner/usuariopartner'
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ]
};

/* Helpers opcionais */
// filtra as rotas pertencentes a um módulo específico
export const getRoutesByModule = (moduleCode) => {
  appRoutes.filter(route => route.moduleCode === moduleCode);
};

// retorna os itens de menu de um módulo específico
export const getMenuByModule = (moduleCode) => {
  menuByModule[moduleCode] || [];
};